import { CSSProperties } from "react";

export interface StyleProps extends CSSProperties {}

export const filterCSSProps = (props: StyleProps) =>
  Object.fromEntries(
    Object.entries(props).filter(([key]) => key in document.body.style)
  );

export const toKebabCase = (str: string) =>
  str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
